import React, { Component } from 'react';

import { AgGridReact } from "@ag-grid-community/react";
import { Loader } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
// import StateSynchronizer from '../../../../../utils/StateSynchronizer';

class ThirteenFReportGrid extends Component {

  constructor(props) {
    super(props);

    this.state = {
      columnDefs: props.thirteenFReportMetaGridColumns,
      defaultColDef: {
        enableCellChangeFlash: true,
        minWidth: 100,
        sortable: true,
        filter: true,
        resizable: true,
      },
      groupDefaultExpanded: 0,
      detailCellRendererParams: {
        detailGridOptions: {
          columnDefs: props.thirteenFReportGridColumns,
          defaultColDef: { sortable: true, resizable: true, filter: true },
          animateRows: true,
          immutableData: false,
        },
        onGridReady: function (params) {
          params.api.setDomLayout("autoHeight");
        },
        getDetailRowData: function (params) {
          params.successCallback(params.data.thirteenFSecReportList);
        },
        getRowNodeId: function (data) {
          return data.guid;
        },
      },
      getRowHeight: function (params) {
        if (params.node && params.node.detail) {
          let length = 2;
          if (params.data.thirteenFSecReportList.length !== 0) {
            length = params.data.thirteenFSecReportList.length;
          }
          var allDetailRowHeight = length * 28;
          return allDetailRowHeight > 13000 ? 13000 : allDetailRowHeight;
        } else {
          return 28;
        }
      },
    };
  }

  getRowNodeId = data => {
    return data.id;
  };

  onGridReady = params => {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

    this.gridApi.closeToolPanel();

    // const COLUMNS_KEY = 'trade--report-grid-col-state';

    // StateSynchronizer.syncGrid(
    //   params,
    //   this.state.columnDefs,
    //   () => localStorageClient.getGridColumnState(COLUMNS_KEY),
    //   s => localStorageClient.saveGridColumnState(COLUMNS_KEY, s)
    // );
  };

  render() {
    const {
      thirteenFReportArray,
      className = 'grid-wrapper',
      loadThirteenFReportActionStatus
    } = this.props;

    const isLoading = loadThirteenFReportActionStatus === ACTION_STATUS.LOGINING;
    if (loadThirteenFReportActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.initLoadThirteenFReportActionStatus();
    }

    return (
      <div className={`ag-theme-balham ${className}`}>
        {isLoading ? (
          <Loader active content="Loading..." />
        ) : (
          <AgGridReact
            // properties
            columnDefs={this.state.columnDefs}
            rowData={thirteenFReportArray}
            defaultColDef={this.state.defaultColDef}
            rowSelection={this.state.rowSelection}
            rowClassRules={this.state.rowClassRules}
            animateRows={true}
            immutableData={false}
            resizable={true}
            sideBar={true}
            getRowNodeId={this.getRowNodeId}
            // master/detail
            masterDetail={true}
            detailCellRendererParams={this.state.detailCellRendererParams}
            getRowHeight={this.state.getRowHeight}
            groupDefaultExpanded={this.state.groupDefaultExpanded}
            // events
            onGridReady={this.onGridReady}
            onSelectionChanged={this.onSelectionChanged}
          />
        )}
      </div>
    );
  }
}

export default ThirteenFReportGrid;